import {
    throwErrorMessage,
    throwSuccessMessage,
    throwErrorWithGenericExternalBusinessError,
} from "../../lib/error_helper";
import {
    analyseRisquesIsLoading,
    fillAnalysesRisques,
    redirectToListPage,
    fillSimplifiedPreventionPlans,
    redirectToLastVisualizedArOrPps,
    fillPartialSpp,
    redirectToArOrPps,
    selectAnalyseRisques,
    setModule,
} from "./analyseRisquesActions";
import { isPPS, canImportFromOpenErp } from "./analyseRisquesStatusActions";
import { checkIntegrity, checkSppAlreadyExists } from "./analyseRisquesCheck";
import {
    castAnalyseRisquesToServerFormat,
    castAnalyseRisquesFromServerFormat,
    castToDbFormat,
} from "./analyseRisquesConversions";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import moment from "moment";
import { guid } from "../../utils";
import db from "../../db";

export function submitOrEditAnalyseRisques(
    analyseRisquesState,
    activeUser,
    moduleSpp,
    riskTypes,
    analysesRisquesState
) {
    return (dispatch) => {
        try {
            checkIntegrity(analyseRisquesState, riskTypes);

            let message = "Êtes-vous sûr(e) de vouloir valider votre ";

            if (moduleSpp) message = message.concat("plan de prévention simplifié?");
            else message = message.concat("analyse de risques?");

            if (!window.confirm(message)) {
                return;
            }

            if (!analyseRisquesState.header.id)
                dispatch(submitAnalyseRisques(analyseRisquesState, activeUser, moduleSpp, analysesRisquesState));
            else dispatch(updateAndConfirmSpp(analyseRisquesState, activeUser, moduleSpp, analysesRisquesState));
        } catch (error) {
            let message = "Erreur lors de la soumission de l'analyse de risques: ";

            if (moduleSpp) message = "Erreur lors de la soumission du plan de prévention simplifié: ";

            console.error(error);

            dispatch(
                throwErrorMessage({
                    errorObject: error,
                    title: "Erreur",
                    message: message + error.message,
                })
            );
        }
    };
}

function submitInDb(ar, dbFormat = false) {
    let arAsDbFormat = ar;

    if (!dbFormat) arAsDbFormat = castToDbFormat(ar);

    return db.transaction("rw?", db.Pps, () => {
        if (!arAsDbFormat.mobileId) arAsDbFormat.mobileId = guid();

        if (!arAsDbFormat.creationDate) arAsDbFormat.creationDate = moment().toString();

        arAsDbFormat.visualizationDate = moment().toString();

        return db.Pps.filter((spp) => spp.mobileId === arAsDbFormat.mobileId)
            .toArray()
            .then((sppList) => {
                if (sppList.length === 0) {
                    return db.Pps.add(arAsDbFormat);
                } else {
                    return db.Pps.update(arAsDbFormat.mobileId, arAsDbFormat);
                }
            });
    });
}

function updateInDb(analyseRisquesState) {
    let ar = castToDbFormat(analyseRisquesState);

    ar.visualizationDate = moment().toString();

    return db.transaction("rw?", db.Pps, () => {
        return db.Pps.update(ar.mobileId, ar);
    });
}

function deleteInDb(analyseRisquesState) {
    db.Pps.delete(analyseRisquesState.header.mobileId);
}

export function submitAnalyseRisques(analyseRisquesState, activeUser, moduleSpp, analysesRisquesState) {
    return (dispatch) => {
        let urlSubmit = "/api/v1/analyseRisques/submitAnalyseRisquesRequest/";

        if (moduleSpp) urlSubmit = "/api/v1/spp/submitSppRequest";

        dispatch(launchValidationRequest(analyseRisquesState, activeUser, moduleSpp, urlSubmit, analysesRisquesState));
    };
}

export function updateAndConfirmSpp(analyseRisquesState, activeUser, moduleSpp, analysesRisquesState) {
    return (dispatch) => {
        let urlUpdateAndConfirm = "/api/v1/spp/updateAndConfirmArRequest/";

        if (moduleSpp) urlUpdateAndConfirm = "/api/v1/spp/updateAndConfirmSppRequest/";

        dispatch(
            launchValidationRequest(
                analyseRisquesState,
                activeUser,
                moduleSpp,
                urlUpdateAndConfirm,
                analysesRisquesState
            )
        );
    };
}

export function launchValidationRequest(analyseRisquesState, activeUser, moduleSpp, url, analysesRisquesState) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        const body = {
            analyseRisques: castAnalyseRisquesToServerFormat(analyseRisquesState),
            userId: activeUser.id,
        };

        dispatch(analyseRisquesIsLoading(true));

        analyseRisquesState.header.validationInProgress = true;
        let success = false;
        let fetchTimeout = 60000;
        let didTimeOut = false;

        new Promise((resolve, reject) => {
            const timeout = setTimeout(() => {
                didTimeOut = true;
                analyseRisquesState.header.validationInProgress = true; //Si on a un timeout on souhaite bloquer

                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Impossible de valider. Vérifiez votre connexion et réessayez",
                    })
                );

                return reject(new Error("Request timed out"));
            }, fetchTimeout);

            fetchWithTimeout(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(body),
                timeout: 60000,
            })
                .then(function (response) {
                    analyseRisquesState.header.validationInProgress = false;
                    dispatch(analyseRisquesIsLoading(false));
                    // Clear the timeout as cleanup
                    clearTimeout(timeout);
                    if (didTimeOut || !response.ok) throw Error(response.statusText);

                    return response;
                })
                .then((response) => response.json())
                .then((value) => {
                    analyseRisquesState.header.id = value.id;
                    analyseRisquesState.header.status = value.status;
                    success = true;
                })
                .catch((err) => {
                    console.error("Erreur : analyseRisquesEditionActions - submit: " + err.message);

                    if (!timeout.cleared) return;

                    analyseRisquesState.header.validationInProgress = false;

                    if (moduleSpp)
                        dispatch(
                            throwErrorWithGenericExternalBusinessError(
                                err,
                                "Erreur lors de la validation du plan de prévention simplifié!"
                            )
                        );
                    else
                        dispatch(
                            throwErrorWithGenericExternalBusinessError(
                                err,
                                "Erreur lors de la soumission de l'analyse de risques!"
                            )
                        );
                })
                .finally(() => {
                    //Si on valide c'est qu'on a forcément déjà enregistré en tant que brouillon
                    //grace à la sauvegarde automatique, donc on met à jour
                    updateInDb(analyseRisquesState).then(() => {
                        let message = "";
                        if (moduleSpp) {
                            message = "Plan de prévention simplifié validé avec succès !";
                            dispatch(fillSimplifiedPreventionPlans(analysesRisquesState));
                        } else {
                            message = "Analyse de risques validée avec succès !";
                            dispatch(fillAnalysesRisques(analysesRisquesState));
                        }

                        if (success) {
                            dispatch(
                                throwSuccessMessage({
                                    title: "Succès",
                                    message: message,
                                })
                            );
                            dispatch(redirectToListPage(moduleSpp, analysesRisquesState));
                        }
                    });

                    dispatch(analyseRisquesIsLoading(false));
                });
        })
            .then(function (response) {
                // Request success and no timeout
                return response;
            })
            .catch(function (err) {
                // Error: response error, request timeout or runtime error
                throw err;
            });
    };
}

export function submitOrEditAsDraft(
    analyseRisquesState,
    activeUser,
    userAction = true,
    moduleSpp,
    analysesRisquesState
) {
    return (dispatch) => {
        try {
            if (!analyseRisquesState.header.mobileId)
                dispatch(submitAsDraft(analyseRisquesState, userAction, analysesRisquesState));
            else dispatch(update(analyseRisquesState, userAction, analysesRisquesState));
        } catch (error) {
            let message = "Erreur lors de la sauvegarde en brouillon de l'analyse de risques: ";

            if (moduleSpp) message = "Erreur lors de la sauvegarde en brouillon du plan de prévention simplifié: ";

            dispatch(
                throwErrorMessage({
                    errorObject: error,
                    title: "Erreur",
                    message: message + error.message,
                })
            );
        }
    };
}

export function submitAsDraft(analyseRisquesState, userAction = true, moduleSpp, analysesRisquesState) {
    return (dispatch) => {
        submitInDb(analyseRisquesState).then(() => {
            if (userAction) {
                let message = "Analyse de risques enregistrée en tant que brouillon !";

                if (moduleSpp) message = "Plan de prévention simplifié enregistré en tant que brouillon !";

                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: message,
                    })
                );

                dispatch(redirectToListPage(moduleSpp, analysesRisquesState));
            }
        });
    };
}

export function update(analyseRisquesState, userAction = true, analysesRisquesState) {
    return (dispatch) => {
        updateInDb(analyseRisquesState).then(() => {
            if (userAction) {
                dispatch(
                    throwSuccessMessage({
                        title: "Succès",
                        message: "Brouillon modifié avec succès !",
                    })
                );

                dispatch(redirectToListPage(isPPS(analyseRisquesState.header.status), analysesRisquesState));
            }
        });
    };
}

export function deleteArOrPps(analyseRisquesState, activeUser, moduleSpp, analysesRisquesState) {
    return (dispatch) => {
        let message = "Êtes-vous sûr(e) de vouloir supprimer ";

        if (moduleSpp) message = message.concat("cette analyse de risques de votre périphérique?");
        else message = message.concat("ce plan de prévention simplifié de votre périphérique?");

        if (!window.confirm(message)) {
            return;
        }

        deleteInDb(analyseRisquesState);
        dispatch(redirectToListPage(moduleSpp, analysesRisquesState));
    };
}

export function transformToSPP(analyseRisquesState, userId) {
    return (dispatch) => {
        dispatch(analyseRisquesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });

        const body = JSON.stringify({
            id: analyseRisquesState.header.id,
            userId: userId,
        });

        fetchWithTimeout("/api/v1/spp/convertArToSpp", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(analyseRisquesIsLoading(false));
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                analyseRisquesState.header.status = "spp_draft";
                updateInDb(analyseRisquesState, false).then(() => {
                    dispatch(redirectToLastVisualizedArOrPps(true));
                    dispatch(setModule(true));
                });
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesEditionActions - transformToSPP", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Impossible de transformer cette analyse de risques en plan de prévention simplifié",
                    })
                );
                dispatch(analyseRisquesIsLoading(false));
            });
    };
}

export function importAndSaveFromOpenErp(id, moduleSpp, user, analysesRisquesState, subcontractors) {
    return (dispatch) => {
        dispatch(analyseRisquesIsLoading(true));

        const headers = new Headers({ "Content-Type": "application/json" });

        return fetchWithTimeout("/api/v1/analyseRisques/getSpp/" + id, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(analyseRisquesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((arFound) => {
                let ar = castAnalyseRisquesFromServerFormat(arFound, user, subcontractors);

                submitInDb(ar, true).then(() => {
                    if (moduleSpp) dispatch(fillSimplifiedPreventionPlans(analysesRisquesState));
                    else dispatch(fillAnalysesRisques(analysesRisquesState));

                    dispatch(redirectToArOrPps(ar.id));
                });
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesEditionActions - importAndSaveFromOpenErp", err);

                let message = "";

                if (moduleSpp) message = "Ce plan de prévention simplifié est introuvable !";
                else message = "Cette analyse de risques est introuvable !";

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: message,
                    })
                );
                dispatch(analyseRisquesIsLoading(false));
            });
    };
}

export function checkAndImportFromOpenErp(partialAr, moduleSpp, user, analysesRisquesState, subcontractors) {
    return (dispatch) => {
        if (!canImportFromOpenErp(partialAr.state)) {
            let message;

            if (moduleSpp) message = "Impossible d'importer ce plan de prévention simplifié car il est en erreur !";
            else message = "Impossible d'importer cette analyse de risques car elle est en erreur !";

            dispatch(
                throwErrorMessage({
                    errorObject: null,
                    title: "Erreur",
                    message: message,
                })
            );

            return;
        }

        checkSppAlreadyExists(partialAr.id).then((alreadyExist) => {
            if (alreadyExist) {
                let message;

                if (moduleSpp)
                    message =
                        "Ce plan de prévention simplifié existe déjà dans l'application, impossible de l'importer à nouveau !";
                else
                    message =
                        "Cette analyse de risques existe déjà dans l'application, impossible de l'importer à nouveau !";

                dispatch(
                    throwErrorMessage({
                        errorObject: null,
                        title: "Erreur",
                        message: message,
                    })
                );

                return;
            }

            dispatch(importAndSaveFromOpenErp(partialAr.id, moduleSpp, user, analysesRisquesState, subcontractors));
        });
    };
}

export function synchroniseArOrSppInError(guid, id, moduleSpp, user, subcontractors) {
    return (dispatch) => {
        dispatch(analyseRisquesIsLoading(true));

        const headers = new Headers({ "Content-Type": "application/json" });

        return fetchWithTimeout("/api/v1/analyseRisques/getSpp/" + id, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                dispatch(analyseRisquesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((arFound) => {
                let ar = castAnalyseRisquesFromServerFormat(arFound, user, subcontractors);

                db.Pps.delete(guid)
                    .then(() => {
                        submitInDb(ar, true)
                            .then(() => {
                                dispatch(selectAnalyseRisques(ar));
                            })
                            .catch((err) => {
                                throw err;
                            });
                    })
                    .catch((err) => {
                        throw err;
                    });
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesEditionActions - synchroniseArOrSppInError", err);

                let message = "";

                if (moduleSpp) message = "Ce plan de prévention simplifié est introuvable !";
                else message = "Cette analyse de risques est introuvable !";

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: message,
                    })
                );
                dispatch(analyseRisquesIsLoading(false));
            });
    };
}

export function searchAnalyseRisques(
    searchInput,
    searchCustomerInput,
    searchAffairInput,
    searchWorkOrderInput,
    agency,
    status,
    moduleSpp
) {
    return (dispatch) => {
        dispatch(analyseRisquesIsLoading(true));
        dispatch(fillPartialSpp([]));

        const headers = new Headers({ "Content-Type": "application/json" });

        const body = JSON.stringify({
            searchInput,
            isSpp: moduleSpp,
            companyId: agency,
            customer: searchCustomerInput,
            workOrder: searchWorkOrderInput,
            affair: searchAffairInput,
            status: status,
        });

        fetchWithTimeout("/api/v1/analyseRisques/search/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                dispatch(analyseRisquesIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((arFound) => {
                dispatch(fillPartialSpp(arFound));
            })
            .catch((err) => {
                console.error("Erreur : analyseRisquesEditionActions - searchAnalyseRisques", err);

                let message = "";

                if (moduleSpp) message = "Ce plan de prévention simplifié est introuvable !";
                else message = "Cette analyse de risques est introuvable !";

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: message,
                    })
                );
                dispatch(analyseRisquesIsLoading(false));
            });
    };
}
